// import { API_AUTH } from "./common";

// const NhanVayApi = {
//   list: ({
//     customerName,
//     phone,
//     dateFrom,
//     dateTo,
//     status,
//     pageIndex,
//     pageSize,
//   }) =>{
//     //alert(dateFrom);
//     return API_AUTH.get(
//       `quan-ly-nhan-vay/danh-sach-nhan-vay?customerName=${customerName}&phone=${phone}&dateFrom=${dateFrom}&dateTo=${dateTo}&status=${status}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
//       {}
//     );
//   },

//   addAndEdit: (
//     customer,
//     nhanVay,
//   ) =>
//   {
//     //alert(customer);
//     //alert(customer.CustomerId);
//     return API_AUTH.post("quan-ly-nhan-vay/them-sua-nhan-vay", {
//       customer,
//       nhanVay,
//     });
//   },
//   getOneDetail: (
//     nhanVayID,
//   ) =>
//   {
//     //alert(customer);
//     //alert(customer.CustomerId);
//     return API_AUTH.get("quan-ly-nhan-vay/chi-tiet-nhan-vay", {
//       nhanVayID ,
//     });
//   }
// };

// export default NhanVayApi;

import { API_AUTH } from "./common";

const NhanVayApi = {
  list: ({
    customerName,
    phone,
    dateFrom,
    dateTo,
    status,
    pageIndex,
    pageSize,
  }) => {
    //alert(dateFrom);
    return API_AUTH.get(
      `quan-ly-nhan-vay/danh-sach-nhan-vay?customerName=${customerName}&phone=${phone}&dateFrom=${dateFrom}&dateTo=${dateTo}&status=${status}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    );
  },

  addAndEdit: ({ customer, nhanVay }) => {
    //alert(customer.CustomerId);
    return API_AUTH.post("quan-ly-nhan-vay/them-sua-nhan-vay", {
      customer,
      nhanVay
    });
  },

  getOneDetail: (nhanVayID) => {
    //alert(customer);
    //alert(customer.CustomerId);
    return API_AUTH.get("quan-ly-nhan-vay/chi-tiet-nhan-vay", {
      nhanVayID,
    });
  },
  // getChiTietHopDong1: (nhanvayId) =>
  //   API_AUTH.get(
  //     `quan-ly-nhan-vay/chi-tiet-nhan-vay?nhanvayId=${nhanvayId}`,
  //     {}
  //   ),

  getChiTietHopDong1: (nhanvayId) =>
    API_AUTH.get(
      `quan-ly-nhan-vay/chi-tiet-nhan-vay?nhanvayId=${nhanvayId}`,
      {}
    ),

  lanThanhToan1: (nhanvayId, pageIndex, pageSize) =>
    API_AUTH.get(
      `quan-ly-nhan-vay/danh-sach-lan-thanh-toan?nhanvayId=${nhanvayId}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),

  getLichSuTraBotGocNhanVay: (nhanvayId) =>
    API_AUTH.get(
      `quan-ly-nhan-vay/lich-su-tra-bot-goc?nhanvayId=${nhanvayId}`,
      {}
    ),
  getLichSuVayThemNhanVay: (nhanvayId) =>
    API_AUTH.get(
      `quan-ly-nhan-vay/lich-su-vay-them?nhanvayId=${nhanvayId}`,
      {}
    ),
  getTaiSanCamCoNhanVay: (nhanvayId) =>
    API_AUTH.get(`quan-ly-nhan-vay/tai-san-cam-co?nhanvayId=${nhanvayId}`, {}),

  getLichSuGiaHanNhanVay: (nhanvayId) =>
    API_AUTH.get(`quan-ly-nhan-vay/lich-su-gia-han?nhanvayId=${nhanvayId}`, {}),

  getLichSuGiaHanNgayTraNhanVay: (nhanvayId) =>
    API_AUTH.get(
      `quan-ly-nhan-vay/lich-su-gia-han-ngay-tra?nhanvayId=${nhanvayId}`,
      {}
    ),

  getGhiChuNhanVay: (nhanvayId) =>
    API_AUTH.get(`quan-ly-nhan-vay/ghi-chu?nhanvayId=${nhanvayId}`, {}),

  getFileDinhKemNhanVay: (nhanvayId) =>
    API_AUTH.get(`quan-ly-nhan-vay/file-dinh-kem?nhanvayId=${nhanvayId}`, {}),

  xoaNhanVay: (nhanvayId) =>
    API_AUTH.post(`quan-ly-nhan-vay/xoa-nhan-vay?nhanvayId=${nhanvayId}`, {}),

  kiemtraSuaNhanVay: (nhanvayId) =>
    API_AUTH.post(`quan-ly-nhan-vay/kiem-tra-sua-nhan-vay?nhanvayId=${nhanvayId}`, {}),


  checkEditNhanVay: (nhanvayId) =>
    API_AUTH.get(
      `quan-ly-nhan-vay/kiem-tra-sua-ten-khach-hang?nhanvayId=${nhanvayId}`,
      {}
    ),

  ghiChuNhanVay: (NhanVayId, GhiChu) => {
    return API_AUTH.post(`quan-ly-nhan-vay/ghi-chu-nhan-vay`, {
      NhanVayId,
      GhiChu,
    });
  },

  LanThanhToanNhanVay: (nhanvayId, pageIndex, pageSize) =>
    API_AUTH.get(
      `quan-ly-nhan-vay/danh-sach-lan-thanh-toan?nhanvayId=${nhanvayId}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
  xoaThanhToanNhanVay: (thuchiId) =>
    API_AUTH.post(
      `quan-ly-nhan-vay/xoa-thanh-toan-nhan-vay?thuchiId=${thuchiId}`,
      {}
    ),

  thanhToanNhanVay: (
    NhanVayId,
    NgayThanhToan,
    NguoiNhan,
    TienThanhToan,
    PhiKhac,
    PhiKho,
    GhiChu
  ) =>
    API_AUTH.post(`quan-ly-nhan-vay/thanh-toan-nhan-vay`, {
      NhanVayId,
      NgayThanhToan,
      NguoiNhan,
      TienThanhToan,
      PhiKhac,
      PhiKho,
      GhiChu,
    }),

  laiDenNgay: (nhanvayId, ngaythanhtoan) =>
    API_AUTH.get(
      `quan-ly-nhan-vay/lay-tien-thanh-toan-nhan-vay?nhanvayId=${nhanvayId}&ngaythanhtoan=${ngaythanhtoan}`,
      {}
    ),

  //Trả nhận vay
  traNhanVay: (
    NhanVayId,
    NguoiNhan,
    NgayThanhToan,
    TienTra,
    PhiKhac,
    PhiKho,
    GhiChu
  ) =>
    API_AUTH.post(`quan-ly-nhan-vay/tra-nhan-vay`, {
      NhanVayId,
      NguoiNhan,
      NgayThanhToan,
      TienTra,
      PhiKhac,
      PhiKho,
      GhiChu,
    }),

  //End-Trả nhận vay

  //Gia hạn ngày trả
  giaHanNgayTra: (
    NhanVayId,
    TienPhaiThu,
    NgayVay,
    KyHan,
    NgayGiaHan,
    LyDoGiaHan
  ) =>
    API_AUTH.post(`quan-ly-nhan-vay/gia-han-ngay-tra-nhan-vay`, {
      NhanVayId,
      TienPhaiThu,
      NgayVay,
      KyHan,
      NgayGiaHan,
      LyDoGiaHan,
    }),

  lichSugiaHanNgayTra: (nhanvayId, pageIndex, pageSize) =>
    API_AUTH.get(
      `quan-ly-nhan-vay/lich-su-gia-han-ngay-tra-nhan-vay?nhanvayId=${nhanvayId}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
  getChiTietGiaHanNgayTra: (nhanvayId) =>
    API_AUTH.post(
      `quan-ly-nhan-vay/chi-tiet-gia-han-ngay-tra-nhan-vay?nhanvayId=${nhanvayId}`,
      {}
    ),
  //End- Gia hạn ngày trả

  //Gia hạn hợp đồng nhận vay
  giaHanHopDongNhanVay: (NhanVayId, MaNhanVay, SoLanGiaHan, LyDoGiaHan) =>
    API_AUTH.post(`quan-ly-nhan-vay/gia-han-hop-dong-nhan-vay`, {
      NhanVayId,
      MaNhanVay,
      SoLanGiaHan,
      LyDoGiaHan,
    }),
  //End-Gia hạn hợp đồng nhận vay

  //trả bớt gốc nhận vay
  traBotGocNhanVay: (
    NhanVayId,
    NguoiNhan,
    NgayThanhToan,
    TienThanhToan,
    PhiKhac,
    PhiKho,
    GhiChu
  ) =>
    API_AUTH.post(`quan-ly-nhan-vay/tra-bot-goc-nhan-vay`, {
      NhanVayId,
      NguoiNhan,
      NgayThanhToan,
      TienThanhToan,
      PhiKhac,
      PhiKho,
      GhiChu,
    }),
  //End-trả bớt gốc nhận vay
  //vaythem
  vayThemNhanVay: (data) =>
    API_AUTH.post(`quan-ly-nhan-vay/vay-them-nhan-vay`, data),
  //Thông tin hợp đồng
  getChiTietHopDong: (nhanvayId, ngaythanhtoan) =>
    API_AUTH.get(
      `quan-ly-nhan-vay/tra-nhan-vay-chi-tiet?nhanvayId=${nhanvayId}&ngaythanhtoan=${ngaythanhtoan}`,
      {}
    ),

  //End thông tin hợp đồng

  //Thông tin hợp đồng
  getLaiDenNgayTraLai: (nhanvayId, ngaythanhtoan) =>
    API_AUTH.get(
      `quan-ly-nhan-vay/lay-tien-thanh-toan-nhan-vay?nhanvayId=${nhanvayId}&ngaythanhtoan=${ngaythanhtoan}`,
      {}
    ),

  getInTraLai: (nhanvayId) =>
    API_AUTH.get(
      `quan-ly-nhan-vay/in-lan-tra-lai-nhan-vay?nhanvayId=${nhanvayId}`,
      {}
    ),
  //End thông tin hợp đồng
};

export default NhanVayApi;
